import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../components/CustomComponent.js";
import ThaiBahtText from "thai-baht-text";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document_no: "",
      created_at: "",
      customer_name: "",
      customer_phone: "",
      customer_address: "",
      customer_tax: "",
      amount: "0.00",
      amount_deposit: "0.00",
      total_pay: "0.00",
      transaction_list: [],
      is_vat: false
    };
  }

  async componentDidMount() {
    loading(false);
    if (params("uid")) {
      await this.Get(params("uid"));
    }
    // window.print();
  }
  Get = async (uid) => {
    loading(true);
// report_receipt_tax(uid,{type: params("type")});
    let result = await GET(params("type") === "billing" ? "admin/billing-notes/list" : params("type") === "invoice" ? "admin/invoices/list" :params("type") === "repair" ? "admin/repairs/list" :params("type") === "billing-notes" ? "admin/billing-notes/list" : "admin/sales/list", { uid });
    if (result?.status) {
      const item = result.data;
      if(params("type") === "billing"){
this.setState({
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer_name || item.customer?.full_name || "-",
        customer_phone: item.customer_phone || item.customer?.phone || "-",
        customer_address: item.customer_address || item.customer?.address || "-",
        customer_tax: item.customer?.tax_number || "-",
        transaction_list: item.invoice || [],
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        total_pay: item.total_pay,
        is_vat: item.is_vat
      });
      }else if(params("type") === "invoice"){
        if(item.sale){
this.setState({
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.sale?.customer_name || item.sale?.customer?.full_name || "-",
        customer_phone: item.sale?.customer_phone || item.sale?.customer?.phone || "-",
        customer_address: item.sale?.customer_address || item.sale?.customer?.address || "-",
        customer_tax: item.sale?.customer?.tax_number || "-",
        transaction_list: item.sale?.transaction_list || [],
        amount: item.sale?.amount,
        amount_deposit: item.sale?.amount_deposit,
        total_pay: item.sale?.total_pay,
        is_vat: item.sale?.is_vat
      });
    }else if(item.repair){
      this.setState({
       document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.repair?.customer_name || item.repair?.customer?.full_name || "-",
        customer_phone: item.repair?.customer_phone || item.repair?.customer?.phone || "-",
        customer_address: item.repair?.customer_address || item.repair?.customer?.address || "-",
        customer_tax: item.repair?.customer?.tax_number || "-",
        transaction_list: [...item.repair?.stock_activity_list.map(e=>e.transaction_list).flat(),...item.repair?.transaction_list] || [],
        amount: item.repair?.amount,
        amount_deposit: item.repair?.amount_deposit,
        total_pay: item.repair?.total_pay,
        is_vat: item.repair?.is_vat
      });
    }
      }else if(params("type") === "repair"){
this.setState({
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer_name || item.customer?.full_name || "-",
        customer_phone: item.customer_phone || item.customer?.phone || "-",
        customer_address: item.customer_address || item.customer?.address || "-",
        customer_tax: item.customer?.tax_number || "-",
        transaction_list: [...item.stock_activity_list.map(e=>e.transaction_list).flat(),...item.transaction_list] || [],
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        total_pay: item.total_pay,
        is_vat: item.is_vat
      });
      }else{
this.setState({
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer_name || item.customer?.full_name || "-",
        customer_phone: item.customer_phone || item.customer?.phone || "-",
        customer_address: item.customer_address || item.customer?.address || "-",
        customer_tax: item.customer?.tax_number || "-",
        transaction_list: item.transaction_list || item.invoice || [],
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        total_pay: item.total_pay,
        is_vat: item.is_vat
      });
      }
      
    }
    loading(false);
  };
  render() {
    const {
      document_no,
      created_at,
      customer_name,
      customer_phone,
      customer_address,
      customer_tax,
      transaction_list,
      amount,
      amount_deposit,
      total_pay,
      is_vat
    } = this.state;
    return (
      <div
        className="mx-auto bg-white p-5 pdf"
        style={{ width: 1116, height: 1579 }}
      >
        <h1 className="fw-bold text-center mb-3">
          ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่
        </h1>
        <h4 className="fw-bold text-center mb-3">
          61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่
          จ.เชียงใหม่
        </h4>
        <h5 className="fw-bold text-center mb-3">
          โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060
        </h5>
        <h2 className="fw-bold text-center mb-4">ใบเสร็จรับเงิน</h2>
        <div className="row mb-3">
          <div className="col-6">
            <h5 className="fw-bold mb-3">เลขที่ : {document_no}</h5>
          </div>
          <div className="col-6">
            <h5 className="fw-bold mb-3">
              วันที่ : {format_date(created_at, "dd mmmm yyyy", "th")}
            </h5>
          </div>

          <div className="col-6">
            <h5 className="fw-bold mb-3">ลูกค้า : {customer_name}</h5>
          </div>
          <div className="col-6">
            <h5 className="fw-bold mb-3">เบอร์โทรศัพท์ : {customer_phone}</h5>
          </div>
          <div className="col-6">
            <h5 className="fw-bold mb-3">ที่อยู่ : {customer_address}</h5>
          </div>
          <div className="col-6">
            <h5 className="fw-bold mb-3">
              เลขประจำตัวผู้เสียภาษี : {customer_tax}
            </h5>
          </div>
        </div>
        <table className="table table-bordered mb-4 text-18">
          <thead>
            <tr className="fw-bold border-0">
              <td className="text-center border-1 wpx-70">
                ลำดับ
                <br />
                No.
              </td>
              <td className="text-center border-1">
                ใบส่งสินค้าเลขที่
                <br />
                Order No.
              </td>
              <td className="text-center border-1">
                วันที่ใบส่งของ
                <br />
                Delivery Date
              </td>
              <td className="text-end border-1">
                จำนวน
                <br />
                Amount
              </td>
              <td className="text-end border-1">
                ยอดชำระ
                <br />
                Amount
              </td>
            </tr>
          </thead>
          <tbody>
            {transaction_list.map((item, index) => (
              <>
              <tr className="border-0">
                <td className="text-center" style={{ border: "0px 1px" }}>
                  {index + 1}
                </td>
                <td className="text-start" style={{ border: "0px 1px" }}>
                  {item.product_code} {item.product_name} {item.remark} {item.document_no}
                </td>
                <td className="text-center" style={{ border: "0px 1px" }}>
                  {format_date(item.created_at || item.sale?.created_at)}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {toFixed(
                    item.sale
                      ? Number(item.sale.amount) * (is_vat ? 1.07 : 1 )
                      : (Number(item.qty) * Number(item.unit_price) * (is_vat ? 1.07 : 1 ))
                  )}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {toFixed(item.total_pay || item.sale?.total_pay)}
                </td>
              </tr>
              {item.credit_note?.map((credit, credit_index)=>(
                <tr className="border-0">
                <td className="text-center" style={{ border: "0px 1px" }}>
                  {index + 1}.{credit_index + 1}
                </td>
                <td className="text-start" style={{ border: "0px 1px" }}>
                  {credit.document_no}
                </td>
                <td className="text-center" style={{ border: "0px 1px" }}>
                  {format_date(credit.created_at)}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  -{toFixed( Number(credit.amount) *  (item.sale?.is_vat || item.is_vat ? 1.07 : 1 ))}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  
                </td>
              </tr>
              ))}
              </>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-0">
              <td className="fw-bold text-start border-1" colSpan={2}>
                รวมเป็นเงิน
              </td>
              <td className="fw-bold text-end border-1">
                ({(()=>{
                let _total = 0;
                for(let item of transaction_list){
                _total += (
                    item.sale
                      ? Number(item.sale.amount) * (is_vat ? 1.07 : 1 )
                      : (Number(item.qty) * Number(item.unit_price) * (is_vat ? 1.07 : 1 ))
                  )
                  if(item?.credit_note){
                  for(let credit of item?.credit_note ){
                     _total -= Number(credit.amount) *  (is_vat || is_vat ? 1.07 : 1 )
                  }
                }
                }
                return ThaiBahtText(Number(_total)) || "ศูนย์บาทถ้วน";
              })()})</td>
              <td className="text-end border-1">{(()=>{
                let _total = 0;
                for(let item of transaction_list){
                _total += (
                    item.sale
                      ? Number(item.sale.amount) * (is_vat ? 1.07 : 1 )
                      : (Number(item.qty) * Number(item.unit_price) * (is_vat ? 1.07 : 1 ))
                  )
                  if(item?.credit_note){
                  for(let credit of item?.credit_note ){
                     _total -= Number(credit.amount) *  (is_vat || is_vat ? 1.07 : 1 )
                  }
                }
                }
                return toFixed(_total);
              })()}</td>
              <td className="text-end border-1">
                {toFixed(total_pay)}
                </td>
            </tr>
          </tfoot>
        </table>

        <table className="table table-bordered mb-4 text-18">
          <tbody>
            <tr className="border-0">
              <td className="fw-bold text-center border-1">ได้รับ/Received</td>
              </tr>
            <tr className="border-0">
              <td className="text-center border-1 pt-5">
                <div>
                  <div className="d-flex mb-4">
                    <input
                      type="checkbox"
                      className="me-3"
                      checked={Number(params("cash_amount"))}
                    />
                    <div className="position-relative">
                      <h5 className="fw-bold">
                        เงินสด/Cash...........................................................................................................................................................................................................................................................................
                      </h5>
                      {Number(params("cash_amount")) > 0 && (
                        <h5
                          className="fw-bold position-absolute"
                          style={{ top: -4, left: 120 }}
                        >
                          {toFixed(Number(params("cash_amount")))}{" "}บาท
                        </h5>
                      )}
                    </div>
                  </div>
                  <div className="d-flex mb-4">
                    <input
                      type="checkbox"
                      className="me-3"
                      checked={Number(params("transfer_amount"))}
                    />
                    <div className="position-relative">
                      <h5 className="fw-bold">
                        โอนเข้าบัญชี/Transfer......................................................................................................................................................................................................................................................
                      </h5>
                      <h5
                          className="fw-bold position-absolute"
                          style={{ top: -4, left: 180 }}
                        >
                          <span className="me-3">{Number(params("transfer_amount")) > 0 ? (toFixed(Number(params("transfer_amount")))) + " บาท" : ""}</span>
                          <span className="me-3">{params("transfer_bank_account") ? "บัญชี: " + (params("transfer_bank_account")) : ""}</span>
                          <span className="me-3">{params("transfer_date") ? "วันที่โอน: " + (format_date(params("transfer_date"))) : ""} {params("transfer_time") ? " "+params("transfer_time") : ""}</span>
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex mb-4">
                    <input
                      type="checkbox"
                      className="me-3"
                      checked={Number(params("credit_amount"))}
                    />
                    <div className="position-relative">
                      <h5 className="fw-bold">
                        เช็ค/Cheque..........................................................................................................................................................................................................................................................................
                      </h5>
                        <h5
                          className="fw-bold position-absolute"
                          style={{ top: -4, left: 180 }}
                        >
                          <span className="me-3">{Number(params("credit_amount")) > 0 ? (toFixed(Number(params("credit_amount")))) + " บาท" : ""}</span>
                          <span className="me-3">{params("credit_bank_account") ? "บัญชี: " + (params("credit_bank_account")) : ""}</span>
                          <span className="me-3">{params("credit_date") ? "วันที่เช็ค: " + (format_date(params("credit_date"))) : ""}</span>
                          <span className="me-3">{params("check_number") ? "เลขที่เช็ค: "+params("check_number") : ""}</span>
                      
                      
                      
                      
                      </h5>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr className="border-0">
              <td className="text-center border-1 pt-5 pb-1 align-end">
                <div className="hpx-40"></div>
                <div>
                  <h5 className="fw-bold mb-4">
                    ผู้รับเงิน..........................................................................
                  </h5>
                  <h5 className="fw-bold mb-4">Bill Collector</h5>
                </div>
                {/* <div>
                  <h5 className="fw-bold mb-4">
                    ผู้รับเงิน..........................................................................
                  </h5>
                  <h5 className="fw-bold mb-4">Authorized Signature</h5>
                </div> */}
              </td>
            </tr>
          </tbody>
        </table>
        <h5 className="mb-4 text-center">
          หากเป็นการชำระด้วยเช็ค ใบเสร็จรับเงินนี้จะสมบูรณ์ เมื่อห้างฯ
          ขึ้นเงินตามเช็คจากธนาคารได้แล้ว
        </h5>
        <h5 className="mb-4 text-center">
          If paid by cheque this cash bill is vlid cheque is cleared.
        </h5>
      </div>
    );
  }
}
